import { SText } from '@setvi/shared/components';

import { AnswerSource } from 'Services';

import { SourceChip, SourcesBox } from './styled';

interface SourcesProps {
  sources: AnswerSource[];
  onCitationClick: (pageNumber: number) => void;
}

/**
 * Page-level citations for an answer. Clicking one takes the user to the
 * passage the answer was grounded in, which is the whole point of doing
 * retrieval rather than summarising the file.
 */
const Sources = ({ sources, onCitationClick }: SourcesProps) => {
  if (!sources?.length) return null;

  // One chip per page, cheapest way to avoid three chips for one page.
  const byPage = sources.reduce<AnswerSource[]>((acc, source) => {
    const seen = acc.some(item => item.pageNumber === source.pageNumber);
    return seen ? acc : [...acc, source];
  }, []);

  return (
    <SourcesBox>
      <SText size="xs" fontColor="#6B7280" title="Sources:" />

      {byPage.map(({ index, pageNumber, sectionHeading }) => (
        <SourceChip
          key={`${index}-${pageNumber}`}
          type="button"
          title={sectionHeading || `Page ${pageNumber}`}
          onClick={() => onCitationClick(pageNumber)}>
          {sectionHeading
            ? `p.${pageNumber} · ${sectionHeading}`
            : `Page ${pageNumber}`}
        </SourceChip>
      ))}
    </SourcesBox>
  );
};

export default Sources;
